import { normalizeBooleanFlag } from './normalizeBooleanFlag';

interface AdditionalField {
  is_account_identifier?: unknown;
  required?: unknown;
  [key: string]: unknown;
}

export const normalizeAdditionalField = (field: AdditionalField): AdditionalField => ({
  ...field,
  is_account_identifier: normalizeBooleanFlag(field?.is_account_identifier as any),
  required: normalizeBooleanFlag(field?.required as any),
});

export const normalizeAdditionalFields = (
  fields: AdditionalField[] | null | undefined,
): AdditionalField[] => (Array.isArray(fields) ? fields.map(normalizeAdditionalField) : []);
